var React = require('react');

function CheckmarkOrange (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},[React.createElement("style",{"key":0},".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#d55a39;}"),React.createElement("clipPath",{"transform":"translate(0 0)","key":1},React.createElement("rect",{"className":"cls-1","width":"24","height":"19"}))]),React.createElement("title",{"key":1},"Asset 1"),React.createElement("g",{"key":2},React.createElement("g",null,React.createElement("g",null,React.createElement("g",{"className":"cls-2"},React.createElement("polygon",{"className":"cls-3","points":"20.29 0 9 11.57 3.71 6.56 0 10.27 9 19 24 3.71 20.29 0"})))))]);
}

CheckmarkOrange.defaultProps = {"viewBox":"0 0 24 19"};

module.exports = CheckmarkOrange;

CheckmarkOrange.default = CheckmarkOrange;
